import { createFileRoute, redirect } from '@tanstack/react-router';
import { PAYMENTS_ACH_BASE_PATH } from '../../../../../../../../features/payments/ach/payments-ach-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/')({
  beforeLoad: () => {
    throw redirect({ to: PAYMENTS_ACH_BASE_PATH });
  },
  preload: false,
});
